import { RegentsExamsStepperTransferCtrl } from './regents-exams-stepper-transfer.controller';

export const RegentsExamsStepperTransferComponent = {
  controller: RegentsExamsStepperTransferCtrl,
  bindings: {
    isLoading: '<',
    schoolSupports: '<',
    studentSupports: '<',
    currentSchool: '<',
  },
  template: require('./regents-exams-stepper-transfer.html'),
};
